import { logger } from '@/server/logger';
import Vue from 'vue';

declare module 'vue/types/vue' {
  interface Vue {
    $logger: typeof logger;
  }
}

const LoggerPlugin = {
  install(VueConstructor: typeof Vue) {
    if (process.server) {
      VueConstructor.prototype.$logger = logger as any;
    } else {
      VueConstructor.prototype.$logger = {
        logError: () => {
          // console.log('[logger stub] logError called on client', args);
        },
      } as any;
    }
  },
};

export default LoggerPlugin;
